import { Product } from '../types/pro'

/**
 * Services and standing items that go on invoices. Materials live in their
 * own catalogue with cost and margin; these are the lines you bill for the
 * work itself, so they carry only a price and a VAT rate.
 */
export const seedProducts: Product[] = [
  {
    productNo: '001',
    name: 'Arbejdsløn elektriker',
    description: 'Autoriseret elektriker, normal arbejdstid.',
    unit: 'timer',
    price: 545,
    vatRate: 0.25,
  },
  {
    productNo: '002',
    name: 'Arbejdsløn lærling',
    description: 'Lærling under opsyn.',
    unit: 'timer',
    price: 350,
    vatRate: 0.25,
  },
  {
    productNo: '003',
    name: 'Arbejdsløn service',
    description: 'Servicebesøg og fejlfinding.',
    unit: 'timer',
    price: 595,
    vatRate: 0.25,
  },
  {
    productNo: '004',
    name: 'Arbejdsløn uden for normal tid',
    description: 'Aften, weekend og helligdage.',
    unit: 'timer',
    price: 795,
    vatRate: 0.25,
  },
  {
    productNo: '005',
    name: 'Servicebil',
    description: 'Kørsel og udkald inkl. værktøj.',
    unit: 'stk',
    price: 350,
    vatRate: 0.25,
  },
  {
    productNo: '006',
    name: 'Kørsel',
    description: 'Kørte kilometer ud over servicebil.',
    unit: 'km',
    price: 4.5,
    vatRate: 0.25,
  },
  {
    productNo: '007',
    name: 'Småmaterialer',
    description: 'Klemmer, skruer, tape og forbrugsstoffer.',
    unit: 'sæt',
    price: 165,
    vatRate: 0.25,
  },
  {
    productNo: '008',
    name: 'Kvalitetssikring og dokumentation',
    description: 'KS-rapport, målinger og aflevering.',
    unit: 'stk',
    price: 850,
    vatRate: 0.25,
  },
  {
    productNo: '009',
    name: 'Tilslutning og idriftsættelse af ladeboks',
    description: 'Opsætning, tilslutning, test og indregistrering.',
    unit: 'stk',
    price: 3500,
    vatRate: 0.25,
  },
  {
    productNo: '010',
    name: 'Eftersyn af elinstallation',
    description: 'Gennemgang med rapport efter gældende regler.',
    unit: 'stk',
    price: 2450,
    vatRate: 0.25,
  },
]
